/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  OperationReportCreateUpdate,
  OperationReportList,
  OperationReportPublishResponse,
  OperationReportRecordsCountRequest,
  OperationReportRecordsSummaryResponse,
  OperationReportsListParams,
  PaginatedOperationReportListList,
  PatchedOperationReportCreateUpdate,
  PurchaseReportResultData,
  ReportResultDownload,
  SalesReportResultData
} from '../../types'
import { apiClient } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const operationReportsList = (
    params?: OperationReportsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedOperationReportListList>(
      {url: `/operation-reports/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getOperationReportsListQueryKey = (params?: OperationReportsListParams,) => {
    return [`/operation-reports/`, ...(params ? [params]: [])] as const;
    }

    
export const getOperationReportsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsList>>, TError = unknown>(params?: OperationReportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsList>>> = ({ signal, pageParam }) => operationReportsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsList>>>
export type OperationReportsListInfiniteQueryError = unknown

export const useOperationReportsListInfinite = <TData = Awaited<ReturnType<typeof operationReportsList>>, TError = unknown>(
 params?: OperationReportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOperationReportsListQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsList>>, TError = unknown>(params?: OperationReportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsList>>> = ({ signal }) => operationReportsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsList>>>
export type OperationReportsListQueryError = unknown

export const useOperationReportsList = <TData = Awaited<ReturnType<typeof operationReportsList>>, TError = unknown>(
 params?: OperationReportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const operationReportsCreate = (
    operationReportCreateUpdate: NonReadonly<OperationReportCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationReportCreateUpdate>(
      {url: `/operation-reports/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: operationReportCreateUpdate
    },
      options);
    }
  


export const getOperationReportsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsCreate>>, TError,{data: NonReadonly<OperationReportCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof operationReportsCreate>>, TError,{data: NonReadonly<OperationReportCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationReportsCreate>>, {data: NonReadonly<OperationReportCreateUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  operationReportsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationReportsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof operationReportsCreate>>>
    export type OperationReportsCreateMutationBody = NonReadonly<OperationReportCreateUpdate>
    export type OperationReportsCreateMutationError = unknown

    export const useOperationReportsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsCreate>>, TError,{data: NonReadonly<OperationReportCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof operationReportsCreate>>,
        TError,
        {data: NonReadonly<OperationReportCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getOperationReportsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const operationReportsRetrieve = (
    operationReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<OperationReportList>(
      {url: `/operation-reports/${operationReportUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getOperationReportsRetrieveQueryKey = (operationReportUuid: string,) => {
    return [`/operation-reports/${operationReportUuid}`] as const;
    }

    
export const getOperationReportsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsRetrieve>>> = ({ signal }) => operationReportsRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsRetrieve>>>
export type OperationReportsRetrieveInfiniteQueryError = unknown

export const useOperationReportsRetrieveInfinite = <TData = Awaited<ReturnType<typeof operationReportsRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsRetrieveInfiniteQueryOptions(operationReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOperationReportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsRetrieve>>> = ({ signal }) => operationReportsRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationReportsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsRetrieve>>>
export type OperationReportsRetrieveQueryError = unknown

export const useOperationReportsRetrieve = <TData = Awaited<ReturnType<typeof operationReportsRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsRetrieveQueryOptions(operationReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const operationReportsUpdate = (
    operationReportUuid: string,
    operationReportCreateUpdate: NonReadonly<OperationReportCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationReportCreateUpdate>(
      {url: `/operation-reports/${operationReportUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: operationReportCreateUpdate
    },
      options);
    }
  


export const getOperationReportsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsUpdate>>, TError,{operationReportUuid: string;data: NonReadonly<OperationReportCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof operationReportsUpdate>>, TError,{operationReportUuid: string;data: NonReadonly<OperationReportCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationReportsUpdate>>, {operationReportUuid: string;data: NonReadonly<OperationReportCreateUpdate>}> = (props) => {
          const {operationReportUuid,data} = props ?? {};

          return  operationReportsUpdate(operationReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationReportsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof operationReportsUpdate>>>
    export type OperationReportsUpdateMutationBody = NonReadonly<OperationReportCreateUpdate>
    export type OperationReportsUpdateMutationError = unknown

    export const useOperationReportsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsUpdate>>, TError,{operationReportUuid: string;data: NonReadonly<OperationReportCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof operationReportsUpdate>>,
        TError,
        {operationReportUuid: string;data: NonReadonly<OperationReportCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getOperationReportsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const operationReportsPartialUpdate = (
    operationReportUuid: string,
    patchedOperationReportCreateUpdate: NonReadonly<PatchedOperationReportCreateUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationReportCreateUpdate>(
      {url: `/operation-reports/${operationReportUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedOperationReportCreateUpdate
    },
      options);
    }
  


export const getOperationReportsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsPartialUpdate>>, TError,{operationReportUuid: string;data: NonReadonly<PatchedOperationReportCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof operationReportsPartialUpdate>>, TError,{operationReportUuid: string;data: NonReadonly<PatchedOperationReportCreateUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationReportsPartialUpdate>>, {operationReportUuid: string;data: NonReadonly<PatchedOperationReportCreateUpdate>}> = (props) => {
          const {operationReportUuid,data} = props ?? {};

          return  operationReportsPartialUpdate(operationReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationReportsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof operationReportsPartialUpdate>>>
    export type OperationReportsPartialUpdateMutationBody = NonReadonly<PatchedOperationReportCreateUpdate>
    export type OperationReportsPartialUpdateMutationError = unknown

    export const useOperationReportsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsPartialUpdate>>, TError,{operationReportUuid: string;data: NonReadonly<PatchedOperationReportCreateUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof operationReportsPartialUpdate>>,
        TError,
        {operationReportUuid: string;data: NonReadonly<PatchedOperationReportCreateUpdate>},
        TContext
      > => {

      const mutationOptions = getOperationReportsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const operationReportsDestroy = (
    operationReportUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/operation-reports/${operationReportUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getOperationReportsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsDestroy>>, TError,{operationReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof operationReportsDestroy>>, TError,{operationReportUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationReportsDestroy>>, {operationReportUuid: string}> = (props) => {
          const {operationReportUuid} = props ?? {};

          return  operationReportsDestroy(operationReportUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationReportsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof operationReportsDestroy>>>
    
    export type OperationReportsDestroyMutationError = unknown

    export const useOperationReportsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsDestroy>>, TError,{operationReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof operationReportsDestroy>>,
        TError,
        {operationReportUuid: string},
        TContext
      > => {

      const mutationOptions = getOperationReportsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Publish an operation report by creating a snapshot of activities.
 */
export const operationReportsPublishCreate = (
    operationReportUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationReportPublishResponse>(
      {url: `/operation-reports/${operationReportUuid}/publish`, method: 'POST'
    },
      options);
    }
  


export const getOperationReportsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsPublishCreate>>, TError,{operationReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof operationReportsPublishCreate>>, TError,{operationReportUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationReportsPublishCreate>>, {operationReportUuid: string}> = (props) => {
          const {operationReportUuid} = props ?? {};

          return  operationReportsPublishCreate(operationReportUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationReportsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof operationReportsPublishCreate>>>
    
    export type OperationReportsPublishCreateMutationError = unknown

    export const useOperationReportsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsPublishCreate>>, TError,{operationReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof operationReportsPublishCreate>>,
        TError,
        {operationReportUuid: string},
        TContext
      > => {

      const mutationOptions = getOperationReportsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieve the latest operation report result and construct it.
 */
export const operationReportsPurchaseResultsRetrieve = (
    operationReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchaseReportResultData>(
      {url: `/operation-reports/${operationReportUuid}/purchase/results`, method: 'GET', signal
    },
      options);
    }
  

export const getOperationReportsPurchaseResultsRetrieveQueryKey = (operationReportUuid: string,) => {
    return [`/operation-reports/${operationReportUuid}/purchase/results`] as const;
    }

    
export const getOperationReportsPurchaseResultsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsPurchaseResultsRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>> = ({ signal }) => operationReportsPurchaseResultsRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsPurchaseResultsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>>
export type OperationReportsPurchaseResultsRetrieveInfiniteQueryError = unknown

export const useOperationReportsPurchaseResultsRetrieveInfinite = <TData = Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsPurchaseResultsRetrieveInfiniteQueryOptions(operationReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOperationReportsPurchaseResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsPurchaseResultsRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>> = ({ signal }) => operationReportsPurchaseResultsRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsPurchaseResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>>
export type OperationReportsPurchaseResultsRetrieveQueryError = unknown

export const useOperationReportsPurchaseResultsRetrieve = <TData = Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsPurchaseResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsPurchaseResultsRetrieveQueryOptions(operationReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const operationReportsResultsDownloadRetrieve = (
    operationReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportResultDownload>(
      {url: `/operation-reports/${operationReportUuid}/results/download`, method: 'GET', signal
    },
      options);
    }
  

export const getOperationReportsResultsDownloadRetrieveQueryKey = (operationReportUuid: string,) => {
    return [`/operation-reports/${operationReportUuid}/results/download`] as const;
    }

    
export const getOperationReportsResultsDownloadRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsResultsDownloadRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>> = ({ signal }) => operationReportsResultsDownloadRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsResultsDownloadRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>>
export type OperationReportsResultsDownloadRetrieveInfiniteQueryError = unknown

export const useOperationReportsResultsDownloadRetrieveInfinite = <TData = Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsResultsDownloadRetrieveInfiniteQueryOptions(operationReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOperationReportsResultsDownloadRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsResultsDownloadRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>> = ({ signal }) => operationReportsResultsDownloadRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsResultsDownloadRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>>
export type OperationReportsResultsDownloadRetrieveQueryError = unknown

export const useOperationReportsResultsDownloadRetrieve = <TData = Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsResultsDownloadRetrieveQueryOptions(operationReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve the latest operation report result and construct it.
 */
export const operationReportsSalesResultsRetrieve = (
    operationReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<SalesReportResultData>(
      {url: `/operation-reports/${operationReportUuid}/sales/results`, method: 'GET', signal
    },
      options);
    }
  

export const getOperationReportsSalesResultsRetrieveQueryKey = (operationReportUuid: string,) => {
    return [`/operation-reports/${operationReportUuid}/sales/results`] as const;
    }

    
export const getOperationReportsSalesResultsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsSalesResultsRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>> = ({ signal }) => operationReportsSalesResultsRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsSalesResultsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>>
export type OperationReportsSalesResultsRetrieveInfiniteQueryError = unknown

export const useOperationReportsSalesResultsRetrieveInfinite = <TData = Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsSalesResultsRetrieveInfiniteQueryOptions(operationReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOperationReportsSalesResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError = unknown>(operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOperationReportsSalesResultsRetrieveQueryKey(operationReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>> = ({ signal }) => operationReportsSalesResultsRetrieve(operationReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(operationReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type OperationReportsSalesResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>>
export type OperationReportsSalesResultsRetrieveQueryError = unknown

export const useOperationReportsSalesResultsRetrieve = <TData = Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError = unknown>(
 operationReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof operationReportsSalesResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOperationReportsSalesResultsRetrieveQueryOptions(operationReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Return the summary of records matching the provided filters.

Request body should contain:
- sites: List of site UUIDs (optional)
- time_periods: List of time period UUIDs (optional)
- tags: List of tag UUIDs (optional)
- goods_types: List of goods types (optional, defaults to both food and packaging)

Returns:
- count: Total number of records matching the filters
 */
export const operationReportsSummaryCreate = (
    operationReportRecordsCountRequest: OperationReportRecordsCountRequest,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OperationReportRecordsSummaryResponse>(
      {url: `/operation-reports/summary`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: operationReportRecordsCountRequest
    },
      options);
    }
  


export const getOperationReportsSummaryCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsSummaryCreate>>, TError,{data: OperationReportRecordsCountRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof operationReportsSummaryCreate>>, TError,{data: OperationReportRecordsCountRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof operationReportsSummaryCreate>>, {data: OperationReportRecordsCountRequest}> = (props) => {
          const {data} = props ?? {};

          return  operationReportsSummaryCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OperationReportsSummaryCreateMutationResult = NonNullable<Awaited<ReturnType<typeof operationReportsSummaryCreate>>>
    export type OperationReportsSummaryCreateMutationBody = OperationReportRecordsCountRequest
    export type OperationReportsSummaryCreateMutationError = unknown

    export const useOperationReportsSummaryCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof operationReportsSummaryCreate>>, TError,{data: OperationReportRecordsCountRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof operationReportsSummaryCreate>>,
        TError,
        {data: OperationReportRecordsCountRequest},
        TContext
      > => {

      const mutationOptions = getOperationReportsSummaryCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    